import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  LeadParagraph,
  Link,
  React
};